export const mapServices = [
  {
    name: 'OpenStreetMap',
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  },
  {
    name: 'Mapbox',
    attribution: '',
    url: 'https://api.mapbox.com/styles/v1/sumitjoshi489/ck9p8m4mp1u1g1js0w9oriz5g/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoic3VtaXRqb3NoaTQ4OSIsImEiOiJjazlwOHFqajMwM3BtM2ZvMjNoNnN6cHJ2In0.0ty1-BfZme7w5m2eNwpIhQ'
  }
];
